import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function importPlansComponent () {
  return import(/* webpackChunkName: "pages/Plans" */ 'pages/Plans')
}

export default function getPlansComponentRouteUtil (props) {
  if (PLAN || (SERVER && global.PLANS)) {
    const Plans = require('pages/Plans').default
    return <Plans {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={importPlansComponent}
        {...props}
      />
    )
  }
}
